import {Types} from 'mongoose';
import * as r from './rate-types.const';

export const RATE_TYPE = {
    type: 'Rate Type',
    category: 'System',
    value: [
        // {_id: new Types.ObjectId(r.RATE_TYPE_DONATED_TIME._id), label: r.RATE_TYPE_DONATED_TIME.label},
        {
            _id: new Types.ObjectId(r.RATE_TYPE_NO_FEE._id),
            label: r.RATE_TYPE_NO_FEE.label,
            description: r.RATE_TYPE_NO_FEE.description,
        },
        {
            _id: new Types.ObjectId(r.RATE_TYPE_FLAT._id),
            label: r.RATE_TYPE_FLAT.label,
            description: r.RATE_TYPE_FLAT.description,
        },
        {
            _id: new Types.ObjectId(r.RATE_TYPE_HOURLY._id),
            label: r.RATE_TYPE_HOURLY.label,
            description: r.RATE_TYPE_HOURLY.description,
        },
        {
            _id: new Types.ObjectId(r.RATE_TYPE_SLIDING_HOURLY._id),
            label: r.RATE_TYPE_SLIDING_HOURLY.label,
            description: r.RATE_TYPE_SLIDING_HOURLY.description,
        },
        // {_id: new Types.ObjectId('507f1f77bcf86cd799443013'), label: 'Percentage'},
        // {_id: new Types.ObjectId(r.RATE_TYPE_SALARIED_HOURLY._id), label: r.RATE_TYPE_SALARIED_HOURLY.label},
        //  {_id: new Types.ObjectId(r.RATE_TYPE_REIMBURSEMENT._id), label: r.RATE_TYPE_REIMBURSEMENT.label},
        {
            _id: new Types.ObjectId(r.RATE_TYPE_TBD._id),
            label: r.RATE_TYPE_TBD.label,
            description: r.RATE_TYPE_TBD.description,
        },
    ].map(d => ({...d, active: true})),
};
